module.exports = __webpack_public_path__ + "static/media/IL.f71d40ad.png";